export interface IAlertListResponse {
  getAlertsForPortal: {
    items: IAlertListItem[];
    totalCount: number;
    __typename: string;
  }
}

export interface IAlertListItem {
  alertId: string;
  alertTrackingId: string;
  read: boolean;
  sendTimeStamp: number;
  title: string;
  alertType?: AlertTypes;
  __typename: string
}

export const enum AlertTypes {
  Alert = 1,
  NewCarcase = 2,
  NewRemitted = 3,
  PGAFormApproved = 4,
};

export type AlertStatus = "New" | "Read" | "Deleted" | "DeletedAll" | "ReadAll";

export interface IFarmGroupStatus {
  groupId: string;
  status: number;
  __typename: string
}

export interface IAlertDetailResponse {
  getAlertDetailForPortal: IAlertDetailResponse
}


export interface IAlertDetailResponse {
  content: string
  errorCode: string
  errorMessage: string
  responseCode: number
  sendDateTime: number
  title: string
  __typename: string
}
